import React, {useCallback, useState} from 'react'
import AccessibilityIcon from '@mui/icons-material/Accessibility'
import AccessibilityNewIcon from '@mui/icons-material/AccessibilityNew'
import {switchUserHandler} from 'module/SessionInfo/api/SwitchUserAPI';
import Tooltip from '@mui/material/Tooltip';
import {css} from '@emotion/react'
import {useTheme} from '@mui/material'

export const SwitchBackToDefaultUserButton = () => {
	const [hover, setHover] = useState(false);
	const theme = useTheme()
	const cssRoot = css`
		display: inline-flex;
		color: ${hover ? theme.palette.error.light : theme.palette.error.main};
		margin: ${theme.spacing(0, 0, 0, 1)};
	`
	const onMouseEnter = useCallback(() => setHover(true), []);
	const onMouseLeave = useCallback(() => setHover(false), []);
	const resetUser = useCallback(() => switchUserHandler({reset: true}), []);
	return (
		<Tooltip title={"Zurück zum eigenen Benutzer wechseln"} enterDelay={0}>
			<div css={cssRoot} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave} onClick={resetUser}>
				{hover &&
					<AccessibilityNewIcon/>
					||
					<AccessibilityIcon/>
				}
			</div>
		</Tooltip>
	);
};